/**
 * Created by Jerker Nord on 2019-02-19.
 */
import {TimelineLite, TimelineMax} from "gsap";
import {GSAPBezierSpline} from "./GSAPBezierSpline";

export class AnimatedMeshRope extends PIXI.Container {

    private _textures:PIXI.Texture[] = [];
    private _curvePoints:number[][];
    private _animateTimeline:TimelineLite;
    private _textureCounter:number;
    private _numberOfTextures:number;
    private _winAnimation:PIXI.SimpleRope;

    constructor() {
        super();
    }

    /**
     * @param textures
     * @param curvePoints
     */
    public createAnimatedMeshRope(textures:PIXI.Texture[], curvePoints:number[][]):void {
        this._textures = textures;
        this._curvePoints = curvePoints;

        this._numberOfTextures = this._textures.length;
        this._textureCounter = 0;
        this._winAnimation = new PIXI.SimpleRope(this._textures[this._textureCounter], GSAPBezierSpline.interpolate(curvePoints));
        this._winAnimation.visible = false;
        this.addChild(this._winAnimation);

        const updatePause:number = 0.033;
        this._animateTimeline = new TimelineMax({repeat : -1, paused : true});
        this._animateTimeline.add(() => this.updateTexture(), "+" + updatePause);
    }

    public getAnimatedMeshRopeTL():TimelineLite {
        const animatedMeshRopeTL:TimelineLite = new TimelineLite({});
        animatedMeshRopeTL.add(() => (this._winAnimation.visible = true));
        animatedMeshRopeTL.add(() => (this._animateTimeline.restart()));
        return animatedMeshRopeTL;
    }

    public stop():void {
        this._winAnimation.visible = false;
        this._animateTimeline.pause();
        this._animateTimeline.kill();
    }

    private updateTexture():void {
        this._textureCounter++;
        if(this._textureCounter < this._numberOfTextures) {
            this._winAnimation.texture = this._textures[this._textureCounter];
        } else {
            this.stop();
            this._textureCounter = 0;
        }
    }
}